import { selectModals } from 'store/modals/selectors';

import { useSelector } from 'hooks';
import { MODALS_LIST } from 'modals/constants';

const ModalsRenderer = () => {
    const { modalId, modalProps } = useSelector(selectModals);

    const ModalComponent = modalId ? MODALS_LIST[modalId] : null;

    if (!ModalComponent) return null;

    return <ModalComponent {...modalProps} />;
};

export default ModalsRenderer;
